import classnames from 'classnames';
import { Form, Formik } from 'formik';
import { pick } from 'lodash';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../store/charts/chartsStore';
import * as Yup from '../common/Yup';
import Message from '../common/message';
import { getParams } from '../common/utils';
import ModalInner from '../layoutItems/modalInner';
import BbInput from '../styling/bbInput';

const KEYS = {
    title: 'title',
    type: 'type',
};

class SaveVisualizationPopup extends React.Component {
    render() {
        return (
            <ModalInner title={this.props.translate('Charts.Visualization.Save.Title')} close={this.props.close}>
                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize={true}
                    validationSchema={this.createValidationSchema()}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        [KEYS.title]: undefined,
                        [KEYS.type]: "dynamic",
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.handleSubmit(values);
                    }}
                >
                    {({ values, setFieldValue, errors }) => (
                        <Form autoComplete="off">
                            {Object.keys(errors).length > 0 && <div className="column">
                                <Message type="error" message={this.props.translate("Error.InvalidParams")} shadowed>
                                    <ul style={{ listStyleType: "disc" }}>
                                        {Object.keys(errors).map(k => <li key={k} style={{ marginLeft: "3em" }}>{this.translateErrorItem(k)}</li>)}
                                    </ul>
                                </Message>
                            </div>}
                            <BbInput name="title" type="text" label={this.props.translate('Charts.Visualization.Title')} placeholder={{ type: 'column' }} />
                            <BbInput type='radio' label={this.props.translate('Charts.Visualization.Type')} placeholder={{ type: 'column' }}
                                options={this.getTypeLabels()}
                                idFormat={(val) => `$radio-chart-visualization-${val}`}
                                checkedValue={values[KEYS.type]}
                                callback={(val) => setFieldValue(KEYS.type, val)}
                            />
                            <div className="modal-inner-buttons">
                                <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.props.close}>
                                    <Translate id='Common.Button.Cancel' />
                                </button>
                                <button type="submit" className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Common.Save" /></button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        )
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const schema = {
            'title': Yup.string().trim().required(wrongInputMsg)
        };
        return Yup.object().shape(pick(schema, ['title']));
    }

    handleSubmit = (values) => {
        this.props.saveVisualizationAs(values, (visualizationId) => {
            let params = getParams(window.location.search);
            params.visualizationId = visualizationId;
            this.props.history.push(`${window.location.pathname}?${new URLSearchParams(params)}`)
        });
        this.props.close();
    }

    translateErrorItem = (item) =>
        (item === null || item === null || item.length < 1) ? null : this.props.translate(`Charts.Visualization.${item[0].toUpperCase()}${item.slice(1)}`)

    getTypeLabels = () => {
        return [
            { label: "Charts.Visualization.Dynamic", value: "dynamic" },
            { label: "Charts.Visualization.Static", value: "static" }
        ];
    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(({ ...chartActions }), dispatch)
)(SaveVisualizationPopup)));
